import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Tooltip, Zoom } from '@mui/material'
import multiply from 'src/assets/Buy_Policy_Images/Multiply.svg'
import Yes from 'src/assets/Buy_Policy_Images/tickYes.svg'
import No from 'src/assets/Buy_Policy_Images/tickNo.svg'
import { COLORS } from 'src/utils/Themes/colors'
import { getTokenForQrReport } from 'src/services/individualService'
import {
  getComparedQuotes,
  getProviderDetails,
} from 'src/services/buyPolicyService'
import LoadingModal from 'src/components/common/LoadingModal'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { useDispatch, useSelector } from 'react-redux'
import {
  removeFromCompareList,
  showNotificationMessage,
  updateProviderDetails,
  updateSelectedQuote,
} from 'src/actions'
import { clearAndDispatchMemberDetails } from 'src/utils/commonMethods/buyPolicy'
import { useHistory } from 'react-router-dom'
import { addScroll } from 'src/utils/commonMethods'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import {
  ERROR_ON_QOUTE,
  REMOVE_QOUTE_COMPARISION,
} from 'src/utils/constants/BuyPolicy'

const CompareModal = ({ compareList, closeModal }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)

  const [loading, setLoading] = useState(false)
  const [comparedQuotes, setComparedQuotes] = useState([])
  const [coverageKeysList, setCoverageKeysList] = useState([])

  useEffect(() => {
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchToken = async (quote = null) => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      if (quote) {
        fetchProviderDetails(token, quote)
      } else {
        fetchComparedQuotes(token)
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchComparedQuotes = async (token) => {
    setLoading(true)

    const formData = {
      addToCompare: [...compareList],
    }
    const response = await getComparedQuotes(token, formData)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        // set the compared quotes
        setCoverageKeysList(responseData?.addToCompareCoverages)
        setComparedQuotes(responseData?.comparedQuotes)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: ERROR_ON_QOUTE,
        })
      )
    }
  }

  const fetchProviderDetails = async (token, quoteDetails) => {
    setLoading(true)

    const response = await getProviderDetails(token, quoteDetails?.providerId)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        dispatch(updateProviderDetails(responseData?.data))
        dispatchAndRedirect(quoteDetails)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  const getCompareContentValue = (content) => {
    if (content?.isPresent?.value) {
      if (content?.limit) {
        return <span className={classes.contentLimit}>{content?.limit}</span>
      } else {
        return <img src={Yes} alt='Yes' height={14} width={18} />
      }
    } else {
      return <img src={No} alt='No' height={14} width={18} />
    }
  }

  const getComparedQuotesRows = () => {
    return coverageKeysList?.map((coverageKeyListItem) => (
      <>
        <TableRow
          className={`${classes.headingContainer} ${classes.borderBottom}`}
          key={`coverageKey_${coverageKeyListItem?.key}`}
        >
          <TableCell align='left' className={classes.comparisonTitleContainer}>
            <span className={classes.coverageKey}>
              {coverageKeyListItem?.value}
            </span>
          </TableCell>
          <>
            {comparedQuotes?.map((quoteDetails) => {
              return (
                <TableCell
                  align='center'
                  className={classes.quoteDetailsContainer}
                  key={`isCoveragePresent_${quoteDetails?.enquiryId}`}
                >
                  {getCompareContentValue(
                    quoteDetails?.addToCompareContents[coverageKeyListItem?.key]
                  )}
                </TableCell>
              )
            })}
          </>
        </TableRow>
      </>
    ))
  }

  const handleRemoveQuote = (quote) => {
    const index = comparedQuotes?.findIndex(
      (listItem) => listItem?.enquiryId === quote?.enquiryId
    )
    setComparedQuotes((comparedQuotes) => comparedQuotes?.splice(index, 1))
    dispatch(removeFromCompareList(quote))
    if (!comparedQuotes?.length) {
      closeModal()
    }
  }

  const dispatchAndRedirect = (quote) => {
    dispatch(updateSelectedQuote(quote))
    addScroll()
    history.push(
      '/individual/dashboard/buyPolicy/health/insuranceDetails/member-details'
    )
  }

  const handleBuy = (quote) => {
    clearAndDispatchMemberDetails(guestUserDetails, dispatch)
    fetchToken(quote)
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.rootContainer}>
        <div className={classes.closeIconContainer} onClick={closeModal}>
          <Tooltip
            TransitionComponent={Zoom}
            placement='bottom'
            title={'Close'}
            arrow
          >
            <img src={multiply} alt='close' height={11} width={11} />
          </Tooltip>
        </div>
        <div className={classes.mainContainer}>
          <TableContainer component={Paper}>
            <Table aria-label='simple table' stickyHeader>
              <TableHead>
                <TableRow className={classes.tableRow}>
                  <TableCell className={classes.comparisonTitleContainer}>
                    <span className={classes.comparisonContent}>
                      Compare: {comparedQuotes.length} items
                    </span>
                  </TableCell>
                  {comparedQuotes?.map((quoteDetails) => {
                    return (
                      <TableCell
                        align='center'
                        key={`providerDetails_${quoteDetails?.enquiryId}`}
                        className={classes.quoteDetailsContainer}
                      >
                        <div className={classes.quoteDetailsContent}>
                          <div
                            className={'cursor-pointer'}
                            onClick={() => handleRemoveQuote(quoteDetails)}
                          >
                            <Tooltip
                              TransitionComponent={Zoom}
                              placement='bottom'
                              title={REMOVE_QOUTE_COMPARISION}
                              arrow
                            >
                              <img
                                src={multiply}
                                alt='close'
                                height={11}
                                width={11}
                              />
                            </Tooltip>
                          </div>
                          <div className={classes.providerDetailsContainer}>
                            <img
                              className={classes.providerImage}
                              src={quoteDetails?.providerImage}
                              alt='Provider'
                            />
                            <span className={classes.providerName}>
                              {quoteDetails?.providerName}
                            </span>
                            <span className={classes.insuranceName}>
                              {quoteDetails?.insuranceName}
                            </span>
                            <span className={classes.amountContainer}>
                              <span className={classes.amountHeading}>
                                Cover:&nbsp;
                              </span>
                              <span className={classes.amountText}>
                                {formatToINR(quoteDetails?.sumInsured)}
                              </span>
                            </span>
                          </div>
                        </div>
                      </TableCell>
                    )
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow className={classes.tableSubRow}>
                  <TableCell className={classes.comparisonTitleContainer}>
                    <span className={classes.coveragesTitle}>
                      Top Coverages
                    </span>
                  </TableCell>
                  <>
                    {comparedQuotes?.map((quoteDetails) => {
                      return (
                        <TableCell
                          align='center'
                          key={`providerDetails_${quoteDetails?.enquiryId}`}
                          className={classes.quoteDetailsContainer}
                        >
                          <span>
                            <span className={classes.amountHeading}>
                              Premium Price:&nbsp;
                            </span>
                            <span className={classes.amountText}>
                              {formatToINR(quoteDetails?.premiumAmount)}
                            </span>
                          </span>
                        </TableCell>
                      )
                    })}
                  </>
                </TableRow>
                {getComparedQuotesRows()}
                <TableRow>
                  <TableCell
                    className={classes.comparisonTitleContainer}
                  ></TableCell>
                  <>
                    {comparedQuotes?.map((quoteDetails) => {
                      return (
                        <TableCell
                          align='center'
                          key={`providerDetails_${quoteDetails?.enquiryId}`}
                          className={classes.quoteDetailsContainer}
                        >
                          <Button
                            className={classes.buyButton}
                            onClick={() => handleBuy(quoteDetails)}
                          >
                            Buy
                          </Button>
                        </TableCell>
                      )
                    })}
                  </>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  )
}

export default CompareModal

const useStyles = makeStyles({
  rootContainer: {
    display: 'flex',
    background: 'white',
    flexDirection: 'column',
    boxSizing: 'border-box',
    borderRadius: '10px',
    padding: '10px',
    maxHeight: '90vh',
    maxWidth: '80vw',
    minWidth: '60vw',
    width: '100%',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'scroll',
  },
  tableRow: {
    '& th': {
      borderBottom: 0,
    },
  },
  tableSubRow: {
    '& td': {
      borderTop: 0,
    },
  },
  closeIconContainer: {
    display: 'flex',
    justifyContent: 'right',
    cursor: 'pointer',
    marginBottom: '10px',
  },
  compareContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  headingContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  comparisonTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    borderRight: '1px solid #C7C7C7',
    padding: '5px',
    width: '40%',
  },
  comparisonContent: {
    fontFamily: 'Roboto',
    fontSize: '19px',
    fontWeight: 'bold',
    textAlign: 'left',
    color: '#2BA6C8',
  },
  quoteDetailsContainer: {
    borderRight: '1px solid #C7C7C7',
    width: '30%',
    '&:last-child': {
      borderRight: '0',
    },
  },
  quoteDetailsContent: {
    display: 'flex',
    gap: '5px',
    justifyContent: 'center',
  },
  providerDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px',
  },
  providerImage: {
    height: '40px',
    width: '85px',
  },
  providerName: {
    fontSize: '10px',
    color: '#666666',
    textAlign: 'center',
  },
  insuranceName: {
    fontSize: '17px',
    color: COLORS.BLACK,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  amountContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  amountHeading: {
    fontSize: '10px',
    color: '#666666',
  },
  amountText: {
    fontSize: '17px',
    color: '#2BA6C8',
    fontWeight: 'bold',
  },
  coveragesTitle: {
    fontSize: '15px',
    color: COLORS.BLACK,
    fontWeight: 'bold',
  },
  borderBottom: {
    borderBottom: '1px solid #C7C7C7',
  },
  noBorderTop: {
    borderTop: 0,
  },
  coverageKey: {
    fontSize: '13px',
    color: '#666666',
    fontWeight: '700 !important',
  },
  buyButton: {
    background: 'linear-gradient(228.98deg, #4EC4E4 9.13%, #0288AC 167.68%)',
    borderRadius: '50px !important',
    width: '100px',
    height: '35px',
    color: `${COLORS.WHITE} !important`,
  },
  contentLimit: {
    fontSize: '14px',
  },
})
